import React from "react";
import { Card, Col, Input, message, Row } from "antd";
import { generateCode } from "../../../../utils/helper";

const { TextArea } = Input;

const WidgetCode = ({ widget }) => {
  const code = generateCode(widget);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(code);
    message.info("Copied!");
  };

  return (
    <Card className="setting_wrapper">
      <Row className="center_items setting_label">
        <Col span={12}>
          <h4 className="p-color">Widget Code</h4>
        </Col>
        <Col span={12} className="action_btn">
          <div onClick={handleCopy} className="action_btn">
            <i className="fa-regular fa-copy"></i>
            <span>Copy</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div className="setting_field">
            <TextArea
              disabled
              style={{ height: 120 }}
              placeholder="Widget Name"
              value={code}
            />
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default WidgetCode;
